import React from 'react';
import { motion } from 'framer-motion';
import PropTypes from 'prop-types';
import './SectionTitle.css';

const SectionTitle = ({ 
  title, 
  subtitle, 
  align = 'center', 
  color = 'primary',
  animate = true
}) => {
  const variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 }
  };

  return (
    <motion.div 
      className={`section-title ${align}`}
      initial={animate ? "hidden" : false}
      whileInView={animate ? "visible" : false}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      {subtitle && (
        <motion.p 
          className={`subtitle ${color}`}
          variants={animate ? variants : null}
          transition={{ duration: 0.6, delay: 0.1 }}
        >
          {subtitle}
        </motion.p>
      )}
      <motion.h2 
        className={`title ${color}`}
        variants={animate ? variants : null}
        transition={{ duration: 0.6, delay: 0.2 }}
      >
        {title}
      </motion.h2>
      <motion.div 
        className={`underline ${color}`}
        variants={animate ? variants : null}
        transition={{ duration: 0.6, delay: 0.3 }}
      />
    </motion.div>
  );
};

SectionTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  align: PropTypes.oneOf(['left', 'center', 'right']),
  color: PropTypes.oneOf(['primary', 'secondary', 'dark', 'light']),
  animate: PropTypes.bool
};

export default SectionTitle;